module.exports = __webpack_public_path__ + "static/Mali-MediumItalic-f9ec90829183a57ba6ecc94dfbbdf3db.ttf";